export default {
  namespaced: true,
  state: {
    page: {
      device: 'desktop',
      styles: '',
      fonts: [],
      scripts: '',
      classes: [],
      components: [],
      sections: [],
      meta: {
        title: '',
        description: ''
      }
    }
  },
  mutations: {
    updateStyles(state, payload) {
      state.page.styles = payload
    },
    updateScripts(state, payload) {
      state.page.scripts = payload
    },
    updateTitle(state, payload) {
      state.page.meta.title = payload
    },
    updateDescription(state, payload) {
      state.page.meta.description = payload
    },
  },
  getters: {
    meta: state => state.page.meta,
    styles: state => state.page.styles,
    scripts: state => state.page.scripts,
    fonts: state => state.page.fonts,
    sections: state => state.page.sections,
    components: state => state.page.components,
    device: state => state.page.device,
  },
  actions: {
    updateOrder({commit}, payload) {
      payload = {...payload, module: 'pageModule'}
      commit('actionsModule/updateElementsOrder', payload, {root: true})
    },
    addToArray({commit}, payload) {
      payload = {...payload, module: 'pageModule'}
      commit('actionsModule/addToArray', payload, {root: true})
    },
    removeFromArray({commit}, payload) {
      payload = {...payload, module: 'pageModule'}
      commit('actionsModule/removeFromArray', payload, {root: true})
    },
    addToObject({commit}, payload) {
      payload = {...payload, module: 'pageModule'}
      commit('actionsModule/addToObject', payload, {root: true})
    },
  }
}